class ComponentDrawer extends HTMLElement {
	constructor() {
		super();


		this.open = false;
		this.opener = document.querySelector('button.component-drawer-open');
		this.container = this.querySelector('.component-drawer-inner');
		this.buttons = Array.from(this.querySelectorAll('nav.component-drawer-nav ul li button'));
		this.subpanelButtons = null;
		this.setAttribute('panel', this.buttons.at(0).getAttribute('aria-controls'));
		this.header = document.querySelector('.shopify-section.section--header');
		this.headerBounds = {};
		this.currentScrollTop = 0;
        this.preventReveal = true;
		this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
	}

	static get observedAttributes() {
		return ['open'];
	}

	get open() {
		return this.getAttribute('open') === 'true' ? true : this.getAttribute('open') === 'false' ? false : null;
	}

	set open(value) {
		this.setAttribute('open', value);
	}

	get currentPanel() {
		return this.getAttribute('panel');
	}

	set currentPanel(value) {
		this.setAttribute('panel', value);
	}

	get currentSubpanel() {
		return this.getAttribute('subpanel');
	}

	set currentSubpanel(value) {
		this.setAttribute('subpanel', value);
	}

	attributeChangedCallback(name, oldValue, newValue) {
		console.log(`${name} changed from ${oldValue} to ${newValue}`);
		if (oldValue === 'false' && newValue === 'true') {
			this.openComponent();
		}

		if (oldValue === 'true' && newValue === 'false') {
			this.closeComponent();
		}
	}

	connectedCallback() {
		this.openerHandler = this.onClickOpener.bind(this);
		this.panelsHandler = this.onClickPanels.bind(this);
		this.scrollHandler = this.onScroll.bind(this);
		this.subpanelHandler = this.openSubpanel.bind(this);
		this.closeSubpanelHandler = this.closeSubpanel.bind(this);


		//this.open = true;

		this.opener.addEventListener('click', this.openerHandler);
		this.buttons.forEach((button) => button.addEventListener('click', this.panelsHandler));
		window.addEventListener('scroll', this.scrollHandler);
		this.createObserver();
	}

	createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > 0) {
			this.classList.add('has-scrolled');
			document.body.classList.add('component-drawer-scrolled');
		}

		if (scrollTop === 0) {
			this.classList.remove('has-scrolled');
			document.body.classList.remove('component-drawer-scrolled');
		}
	}

	onClickOpener() {
		this.open = !this.open;
		this.opener.setAttribute('aria-expanded', this.open);
	}

	openComponent() {
		document.body.classList.add('component-drawer-open');
		this.createPanel();
	}

	closeComponent() {
		document.body.classList.remove('component-drawer-open');
		let component = this;
		setTimeout(function() {
			component.removePanel();
		}, 1000);
	}

	onClickPanels(event) {
		let panelControl = event.currentTarget;
		let panelId = panelControl.getAttribute('aria-controls');
		if (this.currentPanel === panelId) {
			return;
		}
		this.currentPanel = panelId;
		this.buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
		panelControl.setAttribute('aria-expanded', 'true');
		this.removePanel();
		this.createPanel();
	}

	createPanel() {
		let panel = this.getPanel(this.currentPanel);
		this.container.appendChild(panel);

		this.subpanelButtons = Array.from(this.querySelectorAll('.component-drawer-inner .component-drawer-panel button.component-drawer-panel-button'));
		this.subpanelButtons.forEach((button) => {
			//console.log('event')
			//console.log(button)
			button.addEventListener('click', this.subpanelHandler)
		});
		this.subpanels = Array.from(this.querySelectorAll('.component-drawer-inner .component-drawer-panel .component-drawer-subpanel'));


		this.subpanels.forEach((subpanel) => {
			let height = subpanel.scrollHeight;
			subpanel.dataset.height = `${height}px`;
			//subpanel.style.height = '0';
		});
	}

	getPanel(panelId) {
		let templates = document.getElementById('component-drawer-template').content.cloneNode(true);

		let panel = templates.querySelector(`#${panelId}`);

		return panel;
	}

	removePanel() {
		this.subpanelButtons.forEach((button) => {
			//console.log(button)
			button.removeEventListener('click', this.subpanelHandler);
		});
		this.container.querySelector('.component-drawer-panel')?.remove();
	}

	openSubpanel(event) {
		let subpanelControl = event.currentTarget;
		let subpanelId = subpanelControl.getAttribute('aria-controls');
		if (this.currentSubpanel === subpanelId) {
			return;
		}
		this.currentSubpanel = subpanelId;
		this.subpanelButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
		subpanelControl.setAttribute('aria-expanded', 'true');
		this.closeButtonsSubpanel = this.querySelectorAll('.component-drawer-subpanel button.component-drawer-subpanel-back');
		this.closeButtonsSubpanel.forEach((button) => button.addEventListener('click', this.closeSubpanelHandler));

		this.subpanel = this.subpanels.filter((subpanel) => subpanel.getAttribute('id') === subpanelId)[0];
		this.subpanel.dataset.expanded = true;
	}

	closeSubpanel(event) {
		let closeButton = event.currentTarget;
		let subpanel = closeButton.closest('.component-drawer-subpanel');

		subpanel.dataset.expanded = false;
	}

	createSubpanel() {
		let subpanel = this.getSubpanel(this.currentSubpanel);
		this.container.classList.add('subpanel-active');
		this.container.appendChild(subpanel);
		//subpanel.style.minHeight = `${subpanel.offsetHeight}px`;

		this.closeButtonSubpanel = this.querySelector('.component-drawer-subpanel button.component-drawer-subpanel-back');
		this.closeButtonSubpanel.addEventListener('click', this.closeSubpanelHandler);
		let closeButton = this.closeButtonSubpanel

		setTimeout(function() {
			subpanel.dataset.expanded = true;
			closeButton.focus();
		});
	}

	getSubpanel(subpanelId) {
		let templates = document.getElementById('component-drawer-subpanels').content.cloneNode(true);

		let subpanel = templates.querySelector(`#${subpanelId}`);

		return subpanel;
	}
}

customElements.define('component-drawer', ComponentDrawer);